export default class ObjectEqualOptions {
    constructor(init) {
        this.excludeKeys = {};
        this.excludeFunctions = true;
        Object.assign(this, init);
    }
}
//# sourceMappingURL=ObjectEqualOptions.js.map